var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0068 16.9512C6.0068 17.5002 6.4508 17.9472 7.0008 17.9502L14.9938 18.0002H14.9998C15.5498 18.0002 15.9958 17.5562 15.9998 17.0062C16.0038 16.4542 15.5588 16.0032 15.0058 16.0002L9.4478 15.9652L17.7068 7.7072C18.0978 7.3162 18.0978 6.6832 17.7068 6.2932C17.5118 6.0972 17.2558 6.0002 16.9998 6.0002C16.7438 6.0002 16.4878 6.0972 16.2928 6.2932L8.0048 14.5812L7.9998 8.9992C7.9998 8.4472 7.5518 8.0002 6.9998 8.0002H6.9988C6.4468 8.0002 5.9998 8.4492 5.9998 9.0012L6.0068 16.9512Z",
    fill: "#292FC2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 13,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0068 16.9512C6.0068 17.5002 6.4508 17.9472 7.0008 17.9502L14.9938 18.0002H14.9998C15.5498 18.0002 15.9958 17.5562 15.9998 17.0062C16.0038 16.4542 15.5588 16.0032 15.0058 16.0002L9.4478 15.9652L17.7068 7.7072C18.0978 7.3162 18.0978 6.6832 17.7068 6.2932C17.5118 6.0972 17.2558 6.0002 16.9998 6.0002C16.7438 6.0002 16.4878 6.0972 16.2928 6.2932L8.0048 14.5812L7.9998 8.9992C7.9998 8.4472 7.5518 8.0002 6.9998 8.0002H6.9988C6.4468 8.0002 5.9998 8.4492 5.9998 9.0012L6.0068 16.9512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_151)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrom);
export default __webpack_public_path__ + "static/media/from.51766dd037248a5bc53be3c35022b0b4.svg";
export { ForwardRef as ReactComponent };